import { defaultHttpClient } from 'shared/src/api/httpClient';

export type DeleteLikedFolderParams = {
  sno: number;
};

export const deleteLikedFolder = async ({ sno }: DeleteLikedFolderParams) => {
  return defaultHttpClient.request<void>({
    method: 'DELETE',
    url: `/api/v2/members/me/liked_folders/${sno}/`,
  });
};
